import { useTranslation } from "react-i18next"
import { useContext, useMemo } from "react"
import { LockByChallengeModal } from "../modals"
import { RowInfo, ChainSelect } from "../../common"
import { Shimmer } from "../../common/Loading.styles"
import { OrganizeContext } from '../../organize/Organize.context'

const LocksSection = ({ useQuery }) => {
    const { t } = useTranslation()
    const [{ unlock_by_task_id }] = useQuery()
    const { challenges: challengesContext } = useContext(OrganizeContext)
    const { tasks: challenges = [], isLoading } = challengesContext || {}

    const filteredChallenges = [{
        id: '0',
        name: '',
    }].concat(challenges)

    const chainKeys = useMemo(() => {
        const chains = filteredChallenges.map(c => {
            return `${c?.name || ''}-${c?.task_type || ''}`
        }).join('/')
        // Obfuscate chain keys for unique ids and prevent unnecessary re-render
        try {
            return window.btoa(encodeURI(chains))
        } catch {
            // Fallback when obfuscating chain keys failed
            return JSON.stringify(chains)
        }
    }, [filteredChallenges])
    return (
        <>
            <RowInfo help={<LockByChallengeModal />}>
                {
                    isLoading
                        ? <Shimmer type="title" />
                        : <ChainSelect
                            help={t('Locking is optional.')}
                            label={t('Unlock by Completing Challenge')}
                            name="unlock_by_task_ids"
                            backwardCompatibleValue={unlock_by_task_id}
                            useQuery={useQuery}
                            options={filteredChallenges}
                            size="small"
                            childKeys={{ 5: 'trivia', 6: 'multiplechoice', 11: 'multiplechoice' }}
                            key={chainKeys}
                        />
                }
            </RowInfo>
            <span>&nbsp;</span>
        </>
    )
}

export default LocksSection
